import React, { useState } from 'react'
import './footer.css'
import evil from '../../images/evil.png'
import pan from '../../images/pan.png'
import smile from '../../images/smile.png'
import surfboard from '../../images/surfboard.png'
import teapot from '../../images/teapot.png'
import ok from '../../images/ok.svg'
import up from '../../images/up.svg'
import song from '../../song.mp3'
import cover from '../../images/song-cover.png'
import play from '../../images/play.svg'
import pause from '../../images/pause.ico'

function Footer() {

  let [ playing, setPlaying ] = useState(false);

  function playSong() {
    const sng = document.querySelector('.footer__audio');
    if (!playing) {
      sng.play();
      setPlaying(true)
    } else if (playing) {
      sng.pause();
      setPlaying(false)
    }
  }

  return (
    <footer className="footer">
      <div className="footer__container" id="achievements">
        <section className="footer__info">
          <section className="footer__main-figures">
            <div className="footer__info-block">
              <h2 className="footer__header number">10</h2>
              <p className="footer__text subheader">эпизодов</p>
            </div>
            <div className="footer__info-block">
              <h2 className="footer__header number">9 млн</h2>
              <p className="footer__text subheader">зрителей</p>
            </div>
          </section>
        </section>
        <section className="footer__audience title">Аудитория</section>
        <section className="footer__figures">
          <div className="footer__figures-block">
            <h2 className="footer__header-figures number">71%</h2>
            <p className="footer__text-figures subheader">женщины</p>
          </div>
          <div className="footer__figures-block">
            <h2 className="footer__header-figures number">29%</h2>
            <p className="footer__text-figures subheader">мужчины</p>
          </div>
          <div className="footer__figures-block">
            <h2 className="footer__header-figures number">87%</h2>
            <p className="footer__text-figures subheader">iOS и Android</p>
          </div>
          <div className="footer__figures-block">
            <h2 className="footer__header-figures number">13%</h2>
            <p className="footer__text-figures subheader">web</p>
          </div>
          <div className="footer__figures-block">
            <h2 className="footer__header-figures number">30 лет — 44 года</h2>
            <p className="footer__text-figures subheader">средний возраст зрителей</p>
          </div>
        </section>
        <section className="footer__additional">
          <div className="footer__block-additional">
            <h3 className="footer__additional-title title">Интересы зрителей</h3>
            <ul className="footer__additional-list">
              <li className="footer__additional-item text">Музыка</li>
              <li className="footer__additional-item text">Игры</li>
              <li className="footer__additional-item text">Юмор</li>
            </ul>
          </div>
          <div className="footer__block-additional">
            <h3 className="footer__additional-title title">Какие видео смотрели зрители сериала</h3>
            <ul className="footer__additional-list">
              <li className="footer__additional-item text">Музыкальные концерты</li>
              <li className="footer__additional-item text">Юмористические видео</li>
              <li className="footer__additional-item text">Про одежду и аксессуары</li>
            </ul>
          </div>
          <div className="footer__block-additional">
            <h3 className="footer__additional-title title">Неожиданные гео зрителей</h3>
            <ul className="footer__additional-list">
              <li className="footer__additional-item text">Фарерские острова</li>
              <li className="footer__additional-item text">Новая зеландия</li>
              <li className="footer__additional-item text">Чили</li>
            </ul>
          </div>
        </section>
        <section className="footer__watches">
          <h3 className="footer__watches-title title">Больше всего сериал смотрели</h3>
          <ul className="footer__watches-list">
            <li className="footer__watches-item title">Москва</li>
            <li className="footer__watches-item title">Екатеринбург</li>
            <li className="footer__watches-item title">Краснодар</li>
          </ul>
        </section>
        <section className="footer__first-episode">
          <h2 className="footer__first-episode-text text">Первый эпизод сериала вошел в топ-5 среди всех популярных видео, который его зрители смотрели в ОК с 25 марта по 1 июня</h2>
        </section>
        <section className="footer__favourite">
          <h3 className="footer__favourite-title title">Самые любимые эпизоды</h3>
          <div className="footer__favourite-episodes">
            <iframe src="https://ok.ru/videoembed/2466930630196" frameborder="0" className="footer__favourite-episode"></iframe>
            <iframe src="https://ok.ru/videoembed/2522271653428" frameborder="0" className="footer__favourite-episode"></iframe>
            <iframe src="https://ok.ru/videoembed/2522273095220" frameborder="0" className="footer__favourite-episode"></iframe>
          </div>
        </section>
        <section className="footer__favourite-song">
          <h3 className="footer__favourite-song-title title">Самая популярная песня из саундтрека</h3>
          <div className="footer__favourite-song-block">
            <a className="footer__audio-container" style={{ backgroundImage: `url(${cover})` }} href="https://ok.ru/fiveplus/music/15045742422" target="_blank">
              <img src={ playing ? pause : play } alt="" className="footer__audio-play"/>
              {/* <audio className="footer__audio" src={song}></audio> */}
            </a>
            <div className="footer__favourite-song-info">
              <p className="footer__artist-name text">Спелфулл</p>
              <p className="footer__song text">Познакомиться</p>
            </div>
          </div>
        </section>
        <section className="footer__images">
          <img src={evil} alt="" className="footer__image-evil"/>
          <img src={pan} alt="" className="footer__image-pan"/>
          <img src={smile} alt="" className="footer__image-smile"/>
          <img src={surfboard} alt="" className="footer__image-surfboard"/>
          <img src={teapot} alt="" className="footer__image-teapot"/>
          <div className="footer__background"></div>
        </section>
      </div>
      <section className="footer__navigation">
        <img src={ok} alt="" className="footer__image-ok"/>
        <nav>
          <ul className="footer__links">
            <a className="link" href="#watch"><li className="footer__link text">смотреть</li></a>
            <a className="link" href="#plot"><li className="footer__link text">сюжет</li></a>
            <a className="link" href="#heroes"><li className="footer__link text">герои сериала</li></a>
            <a className="link" href="#achievements"><li className="footer__link text">достижения</li></a>
          </ul>
        </nav>
        <aside className="footer__up">
          <p className="text" id="footer__up-text">наверх</p>
          <a href="#top"><img className="footer__up-image" src={up} alt=""/></a>
        </aside>
      </section>
    </footer>
  )
}

export default Footer

// <img src="" alt="" className="footer__audio-stop"/>
